<template>
  <i v-if="isRelevant" class="tm-visual-status">
    <i v-if="$props.isBanner" class="-banner" :style="styleObj">
      <i v-if="!isShort" v-text="bannerText" />
      <i v-if="percentText" v-text="percentText" />
    </i>
  </i>
</template>

<script>
export default {
  name: 'tm-visual-status',

  props: {
    rtpState: { type: Object, required: true },
    isSceneEdit: { type: Boolean, required: true },
    isResizing: { type: Boolean, required: true },
    rectangle: { type: Object, required: true },
    isBanner: { type: Boolean, required: true },
  },

  computed: {
    isRelevant() {
      return (
        !this.$props.isSceneEdit &&
        this.$props.rtpState.show &&
        !this.$props.isResizing
      );
    },

    isShort() {
      return this.$props.rectangle.width < 150;
    },

    styleObj() {
      let colour = '#FFF';

      if (/FAIL|RETRY/.test(this.$props.rtpState.status)) {
        colour = '#e82566';
      }

      return {
        color: colour,
      };
    },

    bannerText() {
      switch (this.$props.rtpState.status) {
        case 'FAIL':
          return 'Preview Failed';
        case 'RETRY':
          return 'Preview Failed. Retrying...';
        case 'RENDER':
        case 'POLL':
          return 'Generating Preview';
        case 'WAIT':
          return 'Processing';
        default:
          return '';
      }
    },

    percentText() {
      let rv = '';
      if (/RENDER|POLL/.test(this.$props.rtpState.status)) {
        rv = `${this.$props.rtpState.percent}%`;
      }
      return rv;
    },
  },
};
</script>

<style lang="scss">
.tm-visual-span .tm-visual-status {
  position: absolute;
  top: 0;
  pointer-events: none;
  background-color: rgba(#000, 0.55);
  z-index: var(--tm-zVisualStatus);

  > .-banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    font-size: 16px;
    font-weight: 400;
    text-shadow: 0 1px 3px #000;
  }
}
</style>
